import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import Utils from 'src/app/common/utils/utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const $: any;

@Component({
  selector: 'app-mobile-announce-banner',
  imports: [TranslateModule],
  templateUrl: './mobile-announce-banner.component.html',
  styleUrl: './mobile-announce-banner.component.scss'
})
export class MobileAnnounceBannerComponent implements OnInit {
  
  isMobile = false;
  showBanner: boolean;
  
  constructor(private translate: TranslateService) {
      this.showBanner = localStorage.getItem('mobileAppBannerClosed') !== 'true';
  }

  ngOnInit(): void {
    this.isMobile = Utils.isIosOrAndroid();

    const bannerClosed = localStorage.getItem('mobileAppBannerClosed');
    if (bannerClosed === 'true') {
      const banner = document.getElementById('mobileAppBanner');
      if (banner) {
        banner.style.display = 'none';
      }
    }
  }

  close() {
    const banner = document.getElementById('mobileAppBanner');
    if (banner) {
      banner.style.display = 'none'; 
      localStorage.setItem('mobileAppBannerClosed', 'true');
      this.showBanner = false;
    }
  }

  showMobileInfo() {
    $('#mobile-app-info').modal('show');
  }

  getMobileApp() {
    if (Utils.isAndroid()) {
      window.open('https://play.google.com/store/apps/details?id=gov.dhs.cbp.pspd.ttmobile');
    } else if (Utils.isIOS()) {
      window.open('https://apps.apple.com/app/id6761013741');
    }
  }

    getGooglePlayBadgeSrc(): string {
    const lang = this.translate.currentLang;
    switch (lang) {
      case 'es':
        return 'assets/images/badges/GetItOnGooglePlay_Badge_Web_color_Spanish.svg';
      case 'fr':
        return 'assets/images/badges/GetItOnGooglePlay_Badge_Web_color_French.svg';
      default:
        return 'assets/images/badges/GetItOnGooglePlay_Badge_Web_color_English.svg';
    }
  }

  getAppStoreBadgeSrc(): string {
    const lang = this.translate.currentLang;
    switch (lang) {
      case 'es':
        return 'assets/images/badges/Download_on_the_App_Store_Badge_ES_RGB_blk_100217.svg';
      case 'fr':
        return 'assets/images/badges/Download_on_the_App_Store_Badge_FR_RGB_blk_100517.svg';
      default:
        return 'assets/images/badges/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
    }
  }
}
